var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "progress indeterminate",
    class: {
      'hidden': !_vm.visible,
      'slide-in-out': _vm.slideInOut
    },
    staticStyle: {
      "max-height": ".25rem"
    }
  }, [_c('div', {
    staticClass: "progress-bar bg-secondary"
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };